module.exports = __webpack_public_path__ + "static/media/pointer.0944b336.svg";